export default "__VITE_ASSET__D0qxclm0__"